import { Fragment } from 'react';
import { Button, type ButtonVariants } from '../../Button';
import { Box } from '../../Core';
import { FormControlSizes } from '../../Form';
import { IconName } from '../../Icons';
import type { EntityAdminPanelAction, EntityAdminPanelActionContent } from '../types';

export function isCustomPanelAction(action: EntityAdminPanelAction): action is EntityAdminPanelActionContent {
  return 'content' in action;
}

export function EntityAdminNewEntityButton({
  entityName,
  createActionEntityName,
  disabled,
  variant,
  onClick,
}: {
  entityName: string;
  /** Label for the New button only; defaults to `entityName`. */
  createActionEntityName?: string;
  disabled: boolean;
  variant?: ButtonVariants;
  onClick: () => void;
}) {
  return (
    <Button
      startIcon={IconName.Plus}
      onClick={onClick}
      variant={variant}
      data-testid="entity-admin-page-new-entity-button"
      size={FormControlSizes.Small}
      disabled={disabled}
    >
      New {createActionEntityName || entityName}
    </Button>
  );
}

export function EntityAdminPanelActionButtons({
  panelActions,
  honorVariant,
  onActionClick,
}: {
  panelActions: EntityAdminPanelAction[];
  honorVariant: boolean;
  onActionClick?: () => void;
}) {
  if (panelActions.length === 0) {
    return null;
  }

  return (
    <Box data-testid="entity-admin-page-panel-actions" display="contents">
      {panelActions.map((action, index) =>
        isCustomPanelAction(action) ? (
          <Fragment key={index}>{action.content}</Fragment>
        ) : (
          <Button
            key={index}
            size={FormControlSizes.Small}
            variant={honorVariant ? action.variant : undefined}
            startIcon={action.startIcon}
            disabled={action.disabled}
            onClick={() => {
              onActionClick?.();
              action.onClick();
            }}
            data-testid={action.testId}
          >
            {action.label}
          </Button>
        )
      )}
    </Box>
  );
}
